export const siteConfig = {
  /* ------------------ BASIC ------------------ */
  name: "Saroop Industries",
  shortName: "Saroop",
  description: "Automotive Solutions: Driving Innovation, Powering Performance",
  url: "https://saroopindustries.com",
  locale: "en-IN",
  country: "India",
  defaultLanguage: "en",

  /* ------------------ BRANDING ------------------ */
  logo: "/logo.png",               // place in /public
  ogImage: "/og-image.png",        // 1200x630
  themeColor: "#0f172a",

  /* ------------------ CONTACT ------------------ */
  email: "saroopindustries@gmail.com",
  supportEmail: "saroopindustries@gmail.com",
  phone: ["+91-9810095059", "+91-9911069000", "+91-9310404500"],
  address:
    "B-15, Mangolpuri Industrial Area Phase-II, New Delhi- 110034, India",
  mapLink:
    "https://www.google.com/maps?q=B-15+Mangolpuri+Industrial+Area+Phase-II+New+Delhi",

  /* ------------------ BUSINESS ------------------ */
  yearEstablished: 2015,
  experience: "10+",
  workingHours: "Mon–Sat, 9:00 AM – 6:00 PM IST",

  brochureUrl: "/Catalouge.pdf",

  /* ------------------ SEO KEYWORDS ------------------ */
  keywords: [
    "automotive electrical parts",
    "fuse box manufacturer",
    "wiring harness manufacturer",
    "glass fuse box",
    "square fuse box",
    "brass terminals",
    "battery cables",
    "automotive components india",
    "Saroop Industries",
  ],

  /* ------------------ SOCIAL ------------------ */
  social: {
    facebook: "https://www.facebook.com/saroopindustries",
    instagram: "https://www.instagram.com/saroopindustries",
    linkedin: "https://www.linkedin.com/company/saroop-industries/",
  },

  /* ------------------ BRANCH OFFICE ------------------ */
  branchOffice: {
    address: "579 Candlestick Circle, Mississauga, Ontario, Canada, L4Z0B3",
    phone: "+1 (647) 568-3866",
    email: "saroopindustries.ca@gmail.com",
    country: "Canada",
  },
} as const;

/* ------------------ COMPANY INFO ------------------ */
export const companyInfo = {
  mission: "Develop a robust global supply chain to ensure efficient production and distribution of automotive industry.",
  vision: "Our commitment to innovation, cutting-edge technology, and staying at the forefront of industry advancements.",
  experience: "10+",
  about: "Established in 2015, Saroop Industries is a leading manufacturer of precision stamping and electrical components for the automotive, appliance, and electronics sectors. Utilizing high-efficiency, Taiwan-made machinery, we specialize in delivering engineering excellence that meets the most stringent global standards.\n\nOur vertically integrated facility ensures total control over quality—from in-house PVC compounding to ISI-compliant wire manufacturing. With a portfolio of 500+ engineered components and certifications including ISO 9001:2015, ISO 14001:2015, ISO 45001:2018, IATF 16949:2016, CE, RoHS, UL, SP, and WHO GMP Certified Quality Product, we are the preferred long-term partner for cost-optimized, high-performance mass production.",
} as const;